module.exports = __webpack_public_path__ + "static/media/logo_foot_m.7b017c85.png";